/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Dutch (Netherlands)
export default {
  'proforma-jira-portal-create.error-flag-handler.portal-create-view-object-search-error-description':
    'Vraag je team of beheerder voor support.',
  'proforma-jira-portal-create.error-flag-handler.portal-create-view-object-search-error-title':
    'We konden geen resultaten ophalen voor deze zoekopdracht',
};
